import {
  prettyPin
} from '@/_utils/pretty-pin'

export default function IndoorOverlay(vm, google, map, options = {}) {

  gm.prototype = new google.maps.OverlayView()

  function gm(vm, map, options) {
    this.vm = vm
    this.bounds = null
    this.map = map
    this.div = []
    this.observer = null
    this.setMap(map)
  }

  function floorUniqueKey(floor) {
    return 'floorMapContainer' + floor._id
  }

  gm.prototype.onAdd = function () {
    const floor = this.vm.selectedFloor
    if (!floor || !floor._id) {
      return
    }

    this.bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(floor.floor_sw_lat, floor.floor_sw_lon),
      new google.maps.LatLng(floor.floor_ne_lat, floor.floor_ne_lon),
    )

    const div = document.createElement('div')
    div.style.borderStyle = 'none'
    div.style.borderWidth = '0px'
    div.style.position = 'absolute'

    // Create the img element and attach it to the div.
    let imgUrl = floor.floor_file
    if (!imgUrl) {
      div.classList.add('indoor--floor--no-img')
      imgUrl = '/blank.png'
    }

    const img = document.createElement('img')
    img.src = imgUrl
    img.id = 'floorMapImg'
    img.style.width = '100%'
    img.style.height = '100%'
    img.style.position = 'absolute'
    div.appendChild(img)

    this.div = div

    const panes = this.getPanes()
    panes.overlayLayer.appendChild(div)
    this.map.setZoom(this.vm.mapZoom)

    // Watch changes and make pretty pins
    prettyPin(this, `${this.vm.keyComponent || ''}indoor`)
  }

  gm.prototype.draw = function () {
    if (!this.bounds) {
      return
    }

    const overlayProjection = this.getProjection();
    const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest())
    const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast())
    const div = this.div

    div.style.left = sw.x + 'px'
    div.style.top = ne.y + 'px'
    div.style.width = (ne.x - sw.x) + 'px'
    div.style.height = (sw.y - ne.y) + 'px'
  }

  gm.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(div)
    }

    this.div = []
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  return new gm(vm, map, options)
}
